interface CadCategoria {
    id_contrato_categoria: number;
    valor: string;
    ID_CATEGORIA: string;
    id_contrato: number;
    cad_categoria: {
        categoria: string;
    };
}

// export default class AdesaoModel {
//     id: number;
//     idTitular: string | null;
//     cpf: string | null;
//     nome: string | null;
//     telefone: string | null;
//     cep: string | null;
//     logradouro: string | null;
//     email: string | null;
//     bairro: string | null;
//     numero: string | null;
//     complemento: string | null;
//     cidade: number | null;
//     estado: number | null;
//     dataSolicitacao: string | null;
//     dataAceite: string | null;
//     aceite: boolean;
//     idEmpresa: string | null;
//     idCategoria: number | null;
//     idGrupo: number | null;
//     numContrato: number | null;
//     motivo: string | null;
//     cad_categoria: CadCategoria | null = null;

//     constructor(
//         id: number,
//         idTitular: string | null,
//         cpf: string | null,
//         nome: string | null,
//         telefone: string | null,
//         cep: string | null,
//         logradouro: string | null,
//         email: string | null,
//         bairro: string | null,
//         numero: string | null,
//         complemento: string | null,
//         cidade: number | null,
//         estado: number | null,
//         dataSolicitacao: string | null,
//         dataAceite: string | null,
//         aceite: boolean,
//         idEmpresa: string | null,
//         idCategoria: number | null,
//         idGrupo: number | null,
//         numContrato: number | null,
//         motivo: string | null,
//         cad_categoria: CadCategoria | null
//     ) {
//         this.id = id;
//         this.idTitular = idTitular;
//         this.cpf = cpf;
//         this.nome = nome;
//         this.telefone = telefone;
//         this.cep = cep;
//         this.logradouro = logradouro;
//         this.email = email;
//         this.bairro = bairro;
//         this.numero = numero;
//         this.complemento = complemento;
//         this.cidade = cidade;
//         this.estado = estado;
//         this.dataSolicitacao = dataSolicitacao;
//         this.dataAceite = dataAceite;
//         this.aceite = aceite;
//         this.idEmpresa = idEmpresa;
//         this.idCategoria = idCategoria;
//         this.idGrupo = idGrupo;
//         this.numContrato = numContrato;
//         this.motivo = motivo;
//         this.cad_categoria = cad_categoria;
//     }

//     static fromApiResponse(data: any): AdesaoModel {
//         return new AdesaoModel(
//             data.id,
//             data.Id_titular || null,
//             data.CPF || null,
//             data.Nome || null,
//             data.Telefone || null,
//             data.CEP || null,
//             data.logradouro || null,
//             data.Email || null,
//             data.Bairro || null,
//             data.Numero || null,
//             data.Complemento || null,
//             data.Cidade || null,
//             data.Estado || null,
//             data.Data_solicitacao || null,
//             data.Data_aceite || null,
//             data.Aceite === "S", 
//             data.Id_Empresa || null,
//             data.Id_categoria || null, 
//             data.Id_grupo || null,
//             data.num_contrato || null,
//             data.motivo || null,
//             data.cad_categoria
//                 ? {
//                     id_contrato_categoria: data.cad_categoria.id_contrato_categoria ?? 0,
//                     valor: data.cad_categoria.valor ?? "",
//                     ID_CATEGORIA: data.cad_categoria.ID_CATEGORIA ?? "",
//                     id_contrato: data.cad_categoria.id_contrato ?? 0,
//                     cad_categoria: {
//                         categoria: data.cad_categoria?.cad_categoria?.categoria ?? "" 
//                     }
//                   }
//                 : null
//         );
//     }
// }

interface CadCategoria {
    id_contrato_categoria: number;
    valor: string;
    ID_CATEGORIA: string;
    id_contrato: number;
    cad_categoria: {
        categoria: string;
    };
}

export default class AdesaoModel {
  id: number;
  nome: string | null;
  cpf: string | null;
  categoria: string | null;
  valor: string | null;
  motivo: string | null;
  aceite: boolean;
  dataSolicitacao: string | null;

  constructor(
    id: number,
    nome: string | null,
    cpf: string | null,
    categoria: string | null,
    valor: string | null,
    motivo: string | null,
    aceite: boolean,
    dataSolicitacao: string | null
  ) {
    this.id = id;
    this.nome = nome;
    this.cpf = cpf;
    this.categoria = categoria;
    this.valor = valor;
    this.motivo = motivo;
    this.aceite = aceite;
    this.dataSolicitacao = dataSolicitacao;
  }

  static fromApiResponse(data: any): AdesaoModel {
    return new AdesaoModel(
      data.id,
      data.nome ?? null,
      data.cpf ?? null,
      data.categoria ?? null,
      data.valor ?? null,
      data.motivo ?? null,
      data.aceite === "S",
      data.data_solicitacao ?? null
    );
  }
}

